<div class="report-container" [ngClass]="rootClassName">
  <div class="report-reportabug">
    <div class="report-container1">
      <div class="report-navigationbar">
        <div class="report-title">
          <div class="frame8pxspacer"></div>
          <div class="report-col3">
            <div class="report-col4">
              <span class="report-text01 headingboldlarge">
                <span>Report A Bug</span>
              </span>
            </div>
          </div>
          <div class="frame8pxspacer"></div>
        </div>
      </div>
      <div class="report-content1">
        <div class="frame16pxspacer"></div>
        <div class="report-row">
          <div class="report-col5">
            <span class="report-text03 labelboldmedium">
              <span>Something not behaving normally</span>
            </span>
          </div>
        </div>
        <div class="frame8pxspacer"></div>
        <div class="report-row1">
          <div class="report-col6">
            <span class="report-text05 labelregularsmall">
              <span>
                Let us know the issue you’re experiencing, and we’ll work to
                resolve it asap.
              </span>
            </span>
          </div>
        </div>
        <div class="frame40pxspacer"></div>
        <div class="report-row2">
          <div class="report-text-input">
            <span class="report-text07 labelregularmedium">
              <span>Email</span>
            </span>
            <div class="report-text-block">
              <span class="report-text09 labelregularmedium">
                <span>Enter email</span>
              </span>
            </div>
          </div>
          <div class="frame24pxspacer"></div>
          <div class="report-select">
            <span class="report-text11 labelregularmedium">
              <span>Type of issue</span>
            </span>
            <div class="report-text-block1">
              <span class="report-text13 labelregularmedium">
                <span>-- Please Select --</span>
              </span>
              <img
                src="/assets/icons/mdiarrowdropdown.svg"
                alt="mdiarrowdropdown"
                class="report-mdiarrowdropdown"
              />
            </div>
          </div>
          <div class="frame24pxspacer"></div>
          <div class="report-text-input1">
            <span class="report-text15 labelregularmedium">
              <span>Add attachment (Optional)</span>
            </span>
            <div class="report-text-block2">
              <span class="report-text17 labelregularmedium">
                <span>click to add attachement</span>
              </span>
            </div>
          </div>
          <div class="frame24pxspacer"></div>
          <div class="report-text-area">
            <div class="report-title1">
              <span class="report-text19">
                <span>
                  Label
                  <span [innerHTML]="rawn9ip"></span>
                </span>
              </span>
              <span class="report-text21">*</span>
            </div>
            <div class="report-text-block3">
              <span class="report-text22 labelregularmedium">
                <span>
                  <span>Hint text</span>
                  <br />
                  <span></span>
                  <br />
                  <span></span>
                  <br />
                  <span></span>
                  <br />
                  <span></span>
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="frame24pxspacer"></div>
        <div class="report-cta">
          <button class="report-buttonnew report-buttonmaster">
            <span class="report-text33 labelmediummedium">
              <span>Submit</span>
            </span>
          </button>
        </div>
        <div class="frame40pxspacer"></div>
      </div>
    </div>
  </div>
</div>
